import React from 'react';

export const RatingColor = ({ value, record }) => {
  if(!record.ciTop || !record.ciBottom || !record.refValue || !record.result || !record.numerator || !record.denominator || !record.refOp || record.assessmentCalc === null) {
    return null;
  }

  const VBo = parseFloat(record.ciTop);
  const VBu = parseFloat(record.ciBottom);
  const R   = parseFloat(record.refValue);
  const E   = parseFloat(record.result);
  const refOp     = record.refOp;
  const refCalc   = record.refCalc;
  const numerator = record.numerator;
  const refValue  = parseFloat(record.refValue);
  const count     = record.indicatorType === 'Anzahl';

  if( numerator > 0 && refCalc.startsWith('S') )
    return <span className={"tableFillColor violet"} ><span></span></span>;
  else if( refOp.startsWith('<') ) {

    if( (!count && VBo <= R ) || (count && numerator <= refValue) )
      return <span className={"tableFillColor darkGreen"} ><span></span></span>;
    else if( !count && E <= R )
      return <span className={"tableFillColor green"} ><span></span></span>;
    else if( !count && VBu <= R )
      return <span className={"tableFillColor orange"} ><span></span></span>;
    else if( (!count && VBu > R ) || (count && numerator > refValue) )
      return <span className={"tableFillColor red"} ><span></span></span>;
  }
  else if( refOp.startsWith('>') ) {
    if( R <= VBu )
      return <span className={"tableFillColor darkGreen"} ><span></span></span>;
    else if( R <= E )
      return <span className={"tableFillColor green"} ><span></span></span>;
    else if( R <= VBo )
      return <span className={"tableFillColor orange"} ><span></span></span>;
    else if ( R > VBo)
      return <span className={"tableFillColor red"} ><span></span></span>;
  }
  return null;
};
